import { render, staticRenderFns } from "./Attachment.vue?vue&type=template&id=aa2a68ae&scoped=true"
import script from "./Attachment.vue?vue&type=script&lang=js"
export * from "./Attachment.vue?vue&type=script&lang=js"
import style0 from "./Attachment.vue?vue&type=style&index=0&id=aa2a68ae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2a68ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa2a68ae')) {
      api.createRecord('aa2a68ae', component.options)
    } else {
      api.reload('aa2a68ae', component.options)
    }
    module.hot.accept("./Attachment.vue?vue&type=template&id=aa2a68ae&scoped=true", function () {
      api.rerender('aa2a68ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/invoices/Attachment.vue"
export default component.exports